/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal Weight Calculator`)
};

const es_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal`)
};

const de_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealgewicht-Rechner`)
};

const nl_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideaal gewichtsrekenmachine`)
};

const fr_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de poids idéal`)
};

const it_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore Peso Ideale`)
};

const pt_br2_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal`)
};

const pt_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal`)
};

const ja_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重計算機`)
};

const zh_hw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_h1", locale)
	if (locale === "en") return en_hw_h1(inputs)
	if (locale === "es") return es_hw_h1(inputs)
	if (locale === "de") return de_hw_h1(inputs)
	if (locale === "nl") return nl_hw_h1(inputs)
	if (locale === "fr") return fr_hw_h1(inputs)
	if (locale === "it") return it_hw_h1(inputs)
	if (locale === "pt-BR") return pt_br2_hw_h1(inputs)
	if (locale === "pt") return pt_hw_h1(inputs)
	if (locale === "ja") return ja_hw_h1(inputs)
	return zh_hw_h1(inputs)
};